import { LitElement, html, observeState, throttler, styles, defineElement  } from "@mds/core";
import { layoutResponsiveCSS } from '@mds/layout';

import { navigationCSS } from './navigation.styles.js';

import './navigation-link.js';

import { navigationState } from './navigation-state.js';



/**
 * Navigation Web Component
 */
export class MdsNavigation extends observeState(LitElement) {
	static get styles() {
		return [...styles, layoutResponsiveCSS, navigationCSS ];
	}

	static get properties() {
		return {
			homeurl: { attribute: 'data-url-home', type: String, reflect: true },
			sitename: { attribute: 'data-site-name', type: String, reflect: true },
			breakpoint: { attribute: 'data-breakpoint', type: Number, reflect: true },
			break: { type: Boolean, reflect: true },
			isopen: {type: Boolean, reflect: true }
		};
	}

	constructor() {
		super();
		this.homeurl = undefined;
		this.breakpoint = '1024';
		this.break = false;
		this.isopen = false;
		this.sitename = 'Mediq';
		window.addEventListener('resize', throttler(this.__setBreakPoint.bind(this)), { passive: true });
		this.addEventListener('click', (event) => {
			this.break && this.haslinks && this.__resizeMobileNav();
		});
		document.body.addEventListener('click', (event) => {
			const safeElem = (/navigation|dropdown/i).test(event.target.tagName);
			if (!safeElem && this.isopen) {
				navigationState.isopen = false;
				this.isopen = navigationState.isopen;
			}
		});
	}

	firstUpdated(changedProperties) {
		this.haslinks = !!this.shadowRoot.host.querySelectorAll('mds-navigation-link').length;
		if(this.haslinks) {
			navigationState.breakpoint = this.breakpoint;
			this.__setBreakPoint();
			this.__resizeMobileNav();
		}
	}

	render() {
		return this.__template();
	}

	__setBreakPoint(){
		navigationState.break = document.documentElement.offsetWidth < navigationState.breakpoint;
		this.break = navigationState.break;
	}

	__resizeMobileNav(){
		requestAnimationFrame(()=>{
			const contentElement= this.shadowRoot.querySelector('.content');
			const corporateElement= this.shadowRoot.querySelector('.corporate');

			contentElement.style=`--offset-top:${this.offsetHeight}px`;
			corporateElement.style=`--offset-top:calc(${this.offsetHeight - 1}px + ${contentElement.offsetHeight}px);`;
		});
	}
	__toggle() {
		navigationState.isopen = !navigationState.isopen;
 		this.isopen = navigationState.isopen;
	}

	/**
	 * Navigation Template
	 * @private
	 */
	__template() {
		return html`
			<a title="${this.sitename} Home Link" href="${encodeURI(this.homeurl)}" class='mds-logo'>${this.sitename}</a>
			<div class='content'><slot name="content"></slot></div>
			<div class='corporate'><slot name="corporate"></slot></div>
			<div class='commerce'><slot name="commerce"></slot></div>
			${this.haslinks && this.break ? html`<div context='subtle' @click='${this.__toggle}' tabindex='0' class='hamburger' ><span>menu</span></div>` : html``}
		`;
	}
}

defineElement('mds-navigation', MdsNavigation);
